/* ARIELLE v47: only show navigation when horizontal overflow exists. */
(function(){
'use strict';
var selector=['.ar22-assurance__inner','.ar22-collection-switch__track','.ar37-benefits__inner','.ar37-tabs__nav','.ar37-table-scroll','.ar35-size-table-wrap','.ar-product-v10__thumbs','.ar-category-strip','.ar-navigation-links','.ar-compact-category-nav'].join(',');
var items=[];
function icon(right){return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="'+(right?'M5 12h14M13 6l6 6-6 6':'M19 12H5m6-6-6 6 6 6')+'"/></svg>';}
function update(item){
var t=item.t,p=item.p;if(!t.isConnected)return;
var over=t.scrollWidth>t.clientWidth+9,visible=t.getClientRects().length>0&&t.clientWidth>0;
item.left.hidden=!over||!visible||t.scrollLeft<=4;
item.right.hidden=!over||!visible||t.scrollLeft+t.clientWidth>=t.scrollWidth-5;
if(over&&visible){
var a=t.getBoundingClientRect(),b=p.getBoundingClientRect(),y=a.top-b.top+p.scrollTop+a.height/2;
item.left.style.top=y+'px';item.right.style.top=y+'px';
item.left.style.left=Math.max(5,a.left-b.left+6)+'px';
item.right.style.right=Math.max(5,b.right-a.right+6)+'px';
p.style.setProperty('--ar-scroll-top',(a.top-b.top+p.scrollTop)+'px');
p.style.setProperty('--ar-scroll-height',a.height+'px');
}
}
function setup(t){
if(t.dataset.arScrollCue==='ready')return;
var p=t.parentElement;if(!p)return;
t.dataset.arScrollCue='ready';p.classList.add('ar-scroll-cue-parent');
var item={t:t,p:p};
['left','right'].forEach(function(side){
var right=side==='right',btn=document.createElement('button');
btn.type='button';btn.className='ar-scroll-cue ar-scroll-cue--'+(right?'next':'prev');
btn.setAttribute('aria-label',right?'Weitere Inhalte nach rechts anzeigen':'Vorherige Inhalte nach links anzeigen');
btn.title=right?'Weiter nach rechts':'Zurück nach links';btn.innerHTML=icon(right);btn.hidden=true;
p.appendChild(btn);item[side]=btn;
btn.addEventListener('click',function(){
var amount=Math.max(160,Math.round(t.clientWidth*.72));
t.scrollBy({left:right?amount:-amount,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
});
});
items.push(item);t.addEventListener('scroll',function(){update(item)},{passive:true});update(item);
}
function scan(){document.querySelectorAll(selector).forEach(setup);items.forEach(update);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
window.addEventListener('load',scan);window.addEventListener('resize',scan,{passive:true});
document.addEventListener('shopify:section:load',scan);
if('ResizeObserver' in window){
var observer=new ResizeObserver(function(){items.forEach(update)});
document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll(selector).forEach(function(t){observer.observe(t);});});
}
})();
